export const getAdditionalVariantCount = (
    count: number
): number | undefined => {
    return count > 4 ? count - 4 : undefined;
};
